function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.91 18.083h.511l.181-.173a4.155 4.155 0 0 1-1.016-2.724C1.586 12.874 3.47 11 5.793 11 8.117 11 10 12.874 10 15.186c0 2.311-1.883 4.185-4.207 4.185a4.2 4.2 0 0 1-2.738-1.01l-.174.18v.508L.964 21 0 20.04l1.91-1.957zm3.883 0a2.901 2.901 0 0 0 2.913-2.897c0-1.604-1.301-2.898-2.913-2.898a2.901 2.901 0 0 0-2.912 2.898c0 1.603 1.3 2.897 2.912 2.897z",
  fill: "#000",
  fillOpacity: 0.54
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 11c0 3.832-3.174 7-7.027 7-.189 0-.376-.008-.56-.023A5.478 5.478 0 0 0 11 15.5c0-.762-.155-1.488-.435-2.148a8 8 0 0 1 .401-.01c1.937 0 3.418.704 4.119 1.476A5.514 5.514 0 0 0 16.6 11c0-3.107-2.515-5.599-5.634-5.599a5.567 5.567 0 0 0-5.516 4.6 5.517 5.517 0 0 0-1.188.139c-.091.013-.18.029-.262.048C4.401 6.728 7.391 4 10.966 4 14.813 4 18 7.168 18 11zm-4.69-1.327c0 1.449-1.026 2.566-2.344 2.56-1.318-.014-2.331-1.111-2.338-2.56-.013-1.367 1.033-2.511 2.338-2.511 1.312 0 2.345 1.144 2.345 2.511z",
  fill: "#000",
  fillOpacity: 0.54
});

var SvgSearchFace = function SvgSearchFace(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_face.347d4200.svg";
export { ForwardRef as ReactComponent };